import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.min.css';
import Map from 'ol/Map';
import View from 'ol/View';
import proj from 'ol/proj';
import {transformExtent,transform} from 'ol/proj';
import WKT from 'ol/format/WKT';
import Select from 'ol/interaction/Select';
import {buffer} from 'ol/extent';

import BorderMask from './ol-geodok/filter/BorderMask';

import commonControls from "./controls"
import commzoneLayersMap from './commercialzone/layer';
import commonLayersMap from './layer';
import config from './config';
import UI from "./ui.js"

import realestateLayersMap from './realestate/layer';
import Externals from './realestate/external';
import realestateservices from "./realestate/services"
import style from "./realestate/styles"

const SESSION_EXTENT_KEY = "realestate_extent";

let customMapOptions = config.getCustomMapOptions();


//layer zusammenstellen
var layers = [];
layers.push(commonLayersMap["baseLayers"])
layers.push(commonLayersMap["overlays"])
commzoneLayersMap["layers"].forEach(layer => layer.setOpacity(0.5));
layers = layers.concat( commzoneLayersMap["layers"]);
layers = layers.concat( realestateLayersMap["layers"]);
layers.push(commonLayersMap["interactivLayerGroup"]);

//workaround for Mask and OSM Layer, works only with dpi 1
//pixelRatio:1
var map = new Map({
	target : 'map',
	pixelRatio:1,
	layers : layers,
	view : new View({
		extent : transformExtent(customMapOptions.extent, "EPSG:25832",
				"EPSG:3857"),
		projection : 'EPSG:3857',
		constrainOnlyCenter:true
	})
});

const resolution = map.getView().getResolutionForExtent(customMapOptions.extent);
const zoom = map.getView().getZoomForResolution(resolution) -1;
map.getView().setMinZoom(zoom)

map.on("change:size",()=> {
  setTimeout(() => {
    const resolution = map.getView().getResolutionForExtent(customMapOptions.extent);
    const zoom = map.getView().getZoomForResolution(resolution) -1;
    map.getView().setMinZoom(zoom)
  },1000);
  
});
// vorherigen extent wieder herstellen, falls vorhanden
var sessionExtent = sessionStorage.getItem(SESSION_EXTENT_KEY);
if(sessionExtent) {
     try {
        map.getView().fit(sessionExtent.split(","),{nearest:true})
    }catch(e) {
        console.error(e)
       
        map.getView().fit(transformExtent(customMapOptions.extent, "EPSG:25832","EPSG:3857"))
        sessionStorage.setItem(SESSION_EXTENT_KEY, map.getView().calculateExtent(map.getSize()));
    }
}else {
   map.getView().fit(
           transformExtent(customMapOptions.extent, "EPSG:25832",
				"EPSG:3857"),{nearest:true})
}

map.on("moveend",function(){
    // Daten im sessionStorage speichern
    sessionStorage.setItem(SESSION_EXTENT_KEY, map.getView().calculateExtent(map.getSize()));
    realestateservices.updateRealestate2(map);
    
    let resolution = map.getView().getResolutionForExtent(transformExtent(customMapOptions.extent, "EPSG:25832","EPSG:3857"))
    let zoom = map.getView().getZoomForResolution(resolution);
    const minZoom = map.getView().getMinZoom()
    if(Math.floor(minZoom) !== Math.floor(zoom)) {
      map.getView().setMinZoom(zoom);
    }
    
})




var bb = new BorderMask({
	wkt : customMapOptions.mask,
	dataProjection : "EPSG:25832",
	featureProjection : "EPSG:3857"
});

commonLayersMap["baseLayers"].getLayers().forEach((layer) => {
    console.log("add mask: " + layer.get("name"));
    layer.addFilter(bb);
});
commonControls.forEach(c => map.addControl(c));


//map click layer filter
//exclude select-, highlite- and searchResult-layer
var layerFilter=function(layer) {
    if(layer === commonLayersMap.selectLayer || layer === commonLayersMap.highliteLayer  || layer === commonLayersMap.searchResultLayer) {
        return false;
    }
    return true;
}

map.on("pointermove", function(event){
     var deselect = true;
    let realestateLayer = realestateLayersMap.realestateLayer;
    let selectStyle = realestateLayer.get("selectStyle");
    
    var pixel = map.getEventPixel(event.originalEvent);
   var hit = map.hasFeatureAtPixel(pixel);
   map.getTargetElement().style.cursor = hit ? 'pointer' : '';
    map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
        //var clone = feature.clone();
        //clone.setStyle(style.realestateStyleFunction(true))
        //commonLayersMap.selectLayer.getSource().addFeature(clone);
        if(layer === realestateLayer) {
            
            if(realestateLayersMap.highlite.feature && realestateLayersMap.selection.feature != realestateLayersMap.highlite.feature) {
                realestateLayersMap.highlite.feature.setStyle(null)
            }
            realestateLayersMap.highlite.feature = feature;
            feature.setStyle(selectStyle)
            deselect=false;
        }
    });
     if(deselect) {
        if(realestateLayersMap.highlite.feature && realestateLayersMap.selection.feature != realestateLayersMap.highlite.feature) {
          realestateLayersMap.highlite.feature.setStyle(null)
        }
        realestateLayersMap.highlite.feature = null;
    }
});
//map click listener
map.on('click', function(event) {
	var coord = transform(event.coordinate, "EPSG:3857", "EPSG:25832")
    var hide = true;
    let realestateLayer = realestateLayersMap.realestateLayer;
    let selectStyle = realestateLayer.get("selectStyle");
    map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
        //var clone = feature.clone();
        //clone.setStyle(style.realestateStyleFunction(true))
        //commonLayersMap.selectLayer.getSource().addFeature(clone);
        if(layer === realestateLayer) {
            if(realestateLayersMap.selection.feature) {
                realestateLayersMap.selection.feature.setStyle(null)
            }
            realestateLayersMap.selection.feature = feature;
            feature.setStyle(selectStyle)
            hide=false;
            realestateservices.fetchRealestateInfo(feature.get("env"),"")
        }
    });
    if(hide) {
        if(realestateLayersMap.selection.feature) {
            realestateLayersMap.selection.feature.setStyle(null)
        }
        realestateLayersMap.selection.feature = null;
        realestateLayersMap.selection.point = null;
        $(".selectinfo").hide()
    }
    
});



var ui = new UI(map);
ui.initializeUI();
ui.initAutocompleteOptions();

var externals = new Externals(map,ui);

externals.replaceMap();
setTimeout(function(){map.updateSize()},20);






$( window ).resize(function() {
    setTimeout(function(){externals.replaceMap()},50);

});




window.doDeselectAndHidePopup = externals.doDeselectAndHidePopup.bind(externals);

window.updateOpacity = externals.updateOpacity.bind(externals);


window.replaceMap=externals.replaceMap.bind(externals);

window.onPageEvent=externals.onPageEvent.bind(externals);

window.onResetEvent=externals.onResetEvent.bind(externals);

window.onSearchEvent=externals.onSearchEvent.bind(externals);

window.zoomTo=externals.zoomTo.bind(externals);

window.doHighlite=externals.doHighlite.bind(externals);
window.doSearch=externals.doSearch.bind(externals);

window.fetchRealestateInfoByID=realestateservices.fetchRealestateInfoByID.bind(realestateservices);
window.fetchRealestateInfo=realestateservices.fetchRealestateInfo.bind(realestateservices);



